module.exports = __webpack_public_path__ + "img/r0.c232a011.jpg";